import Vue from 'vue'
import { parse, unparse } from 'papaparse'

const state = {
}

const getters = {
    status2variant(state) {
        return (status) => {
            const table = {
                'saved': 'dark',
                'paid': 'dark',
                'shipped': 'success',
                'canceled': 'success',
                //'listed': 'info',
                //'sold': 'danger',
                //'': 'warning',
            }
            return table[status]
        }
    },
}

const mutations = {
}

const actions = {
    async save (context, data) {
        return axios.post('/api/v1/marunage' + (data.uuid ? '/' + data.uuid : ''), data)
            .then((response) => {
                return response
            })
            .catch((error) => {
                return Promise.reject(error.response.data.errors || {})
            })
    },
    async destroy (context, data) {
        if (data.id === undefined) {
            return {
                data: {
                    data: {
                    },
                },
            }
        }
        return axios.delete('/api/v1/marunage/' + data.id)
            .then((response) => {
                return response
            })
            .catch((error) => {
                return Promise.reject(error.response.data.errors || {})
            })
    },
    async index (context, data) {
        let config = {
            params: (typeof data === 'object' ? data : null)
        }
        if (typeof data === 'object' && data.download) {
            config.responseType = 'blob'
            config.dataType = 'binary'
            config.headers = { 'Cache-Control': 'no-cache' }
        }
        return axios
            .get('/api/v1/marunage' + (typeof data  === 'string' ? '/' + data : ''), config)
            .then(async (response) => {
                if (typeof data === 'object' && data.download) {
                    Vue.prototype.download(response)
                }
                return response
            })
            .catch((error) => {
                return Promise.reject(error.response.data.errors || {})
            })
    },
    async download (context, data) {
        data = Object.assign(data, { download: true, })
        const response = await axios.get('/api/v1/marunage', {
            params: (typeof data === 'object' ? data : null),
            responseType: 'blob',
            dataType: 'binary',
            headers: { 'Cache-Control': 'no-cache' },
        })
        .catch(error => error.response || null)
        Vue.prototype.download(response)
        return response
    },
    async upload_js (context, data) {
        return new Promise((resolve, reject) => {
            parse(data, {
                header: true,
                skipEmptyLines: 'greedy',
                complete: (results) => {
                    resolve(results?.data)
                },
                error: () => {
                    reject(new Error('csv parse err'))
                },
            })
        })
    },
    download_js (context, data) {
        return unparse(data.rows, {
            header: true,
            skipEmptyLines: 'greedy',
            columns: data.culumns,
            quotes: true,
        })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}

